module.exports = __webpack_public_path__ + "img/back.4ce29850.png";